import { Link } from "react-router-dom";
import ScoopCard from "@/components/feature/ScoopCard";
import { scoops } from "@/mocks/scoops";

export default function RelatedScoops({ currentId, category }: { currentId: string; category: string }) {
  const sameCategory = scoops.filter((s) => s.id !== currentId && s.category === category);
  const others = scoops.filter((s) => s.id !== currentId && s.category !== category);
  const related = [...sameCategory, ...others].slice(0, 3);

  if (related.length === 0) return null;

  return (
    <section className="border-t border-foreground-950/10 bg-background-100">
      <div className="mx-auto w-full max-w-shell px-4 py-14 md:px-6 md:py-16">
        <div className="flex items-end justify-between gap-4">
          <div>
            <span className="inline-flex items-center gap-2 text-xs font-medium uppercase tracking-[0.2em] text-primary-600">
              <span className="h-px w-6 bg-primary-500" aria-hidden="true"></span>
              相关推荐
            </span>
            <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              你或许还想看
            </h2>
          </div>
          <Link
            to="/scoops"
            className="hidden shrink-0 items-center gap-1.5 whitespace-nowrap text-sm font-medium text-primary-700 transition-colors hover:text-primary-800 sm:flex"
          >
            返回爆料库
            <i className="ri-arrow-right-line text-base" aria-hidden="true"></i>
          </Link>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {related.map((scoop) => (
            <ScoopCard key={scoop.id} scoop={scoop} />
          ))}
        </div>
      </div>
    </section>
  );
}